import {gql} from '@apollo/client'

export const UPDATE_WINE_CLUB_ORDER = gql`
  mutation UpdateWineClubOrder($wineClubOrder: UpdateWineClubOrderInput!) {
    updateWineClubOrder(input: $wineClubOrder) {
      clientMutationId
    }
  }
`
